function scrollToTop() {
    scroll({
        top: 0,
        behavior: "smooth"
    });
}

export {scrollToTop};